module.exports = __webpack_public_path__ + "static/media/DOUGL.a3c41f25.svg";